import { Validators } from '@angular/forms';
import { sectorGroup } from './sector-group';
/**
 * routing Group _ Osman
 * create a routing from text Form
 * @param fb : FormBuilder
 */
export function routingFormGroup (fb: any):any {
    return fb.group({
        code: fb.control(''),
        id: fb.control(''),
        suffix: fb.control(''),
        xType: fb.control(''),
        breakIndex: fb.control(''),
        // FIXME : direction + lcoation to remove not returned in the request
        direction: fb.control(''),
        locations: fb.control(''),
        carrier: fb.control('', Validators.required),
        sector: sectorGroup(fb)
    });
}
